import {Component, ViewChild} from '@angular/core';
import {ModalController, NavController, NavParams, ViewController} from "ionic-angular";
import {Api} from "../../providers/api";
import {CartManager} from "../../providers/cart-manager";
import {ShipmentcartManagerProvider} from "../../providers/shipmentcart-manager";
import {GVLogger} from "../../services/gv-logger";
import {Storage} from "@ionic/storage";
import {StockcartManager} from "../../providers/stockcart-manager";
import {ItemPage} from "../item-details/item-details";
import {Constants} from "../../providers/config";

@Component({
  selector: 'page-mark-bad-product-model',
  templateUrl: 'mark-bad-product-model.html',
})
export class MarkBadProductModelPage {
  items = [];
  cacheImages:any;
  private product: any;
  public constants = Constants;
  damagedProductComment = "";
  openedProductComment = "";
  damagedQuntity = 0;
  openedQuantity = 0;
  enteredQuantityInDamaged = 0;
  enteredQuantityInOpened = 0;
  badProductConditions;
  markBadList = [];


  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private viewCtrl:ViewController,
              private storage:Storage,
              private stockCartManager: StockcartManager,
              private modalController:ModalController,
              private gVLogger: GVLogger,
              private cartManager:CartManager,
              public api:Api) {
    this.items.push(this.navParams.get('item'));
    this.product = this.navParams.get('item');
    // this.badProductConditions = this.navParams.get('badProductConditions');
    // this.gVLogger.log("badProductConditions from nav params "  + JSON.stringify(this.badProductConditions) );

    // for(let badInventory of this.badProductConditions){
    //   let badProductObj = {
    //       code:badInventory.code,
    //       type: badInventory.desctiption,
    //       quantity : 0,
    //       comment : ""
    //   };
    //   this.markBadList.push(badProductObj);
    // this.markBadList = this.product.markBadList;

    // }

    this.gVLogger.log("badProductConditions after allinment "  + JSON.stringify(this.product.badProductDtoList) );
    // this.product.quantity = this.product.totalQuantityShipmentNotice;

    this.storage.get("cacheImages").then((cache)=>{
      this.cacheImages = cache;
    });
  }

  totalBadQuantity(){
    let totalBad = 0;
    for(let bad of this.product.badProductDtoList){
      this.gVLogger.log("Bad total : " + bad.quantity)
      totalBad += Number(bad.quantity);
    }
    return totalBad;
  }

  totalGoodQuantity(){
    let totalBad = 0;
    for(let bad of this.product.badProductDtoList){
      this.gVLogger.log("Good total : " + totalBad)
      totalBad += Number(bad.quantity);
    }
    return Number(this.product.quantity) - Number(totalBad);
  }

  ionViewDidLoad() {
    this.gVLogger.log('ionViewDidLoad ReceiveStockPopupPage');
  }

  close(){
    this.viewCtrl.dismiss();
  }

  addProductToCartOnOk(){
    this.gVLogger.log("badProductConditions after allinment "  + JSON.stringify(this.product.badProductDtoList) );
    // let userName = "";
    // this.storage.get("userName").then((data) =>{
    //   this.gVLogger.log("Dataa : " + data);
    //   userName = data;
    // })

    // this.gVLogger.log("Dataa UserName: " + userName);
    // for(let bad of this.product.badProductDtoList){
    //   if(bad.comment !== "" && bad.comment !== null){
    //       bad.comment = btoa(userName + ": " + bad.comment);
    //   }
    // }
    this.viewCtrl.dismiss(this.product.badProductDtoList);
  }

  gotoSingleView(product){
    this.api.get("product/" + product.id + "/?isWebStore=" + 1).map(res => res.json()).subscribe(data => {
      if(data.status === "200"){
        product.description = data.data.description;
      }
    })
    this.navCtrl.push(ItemPage, {item: product, "status" : "fromReceiveStock"});
  }

  // makeImageURL(dimensions,item){
  //   return this.stockCartManager.makeImageURL(dimensions,item);
  // }

  makeImageURL(dimensions,item){
    this.gVLogger.log("Make Image URl:::::::: " + this.cartManager.makeImageURL(dimensions,item));

    if(item.productImagesDTO[0].name === "dummy" || item.productImagesDTO[0].name === "dummy"){
      if(this.constants.isWebstore){
        return this.cartManager.makeNANImageURLFromImage(dimensions);
      }
      else{
        return "./assets/img/dummy-"+dimensions+".png";
      }
    }else{
      this.gVLogger.log("UUUUUUUURRRRRrl " + this.cartManager.makeImageURL(dimensions,item));
      return this.cartManager.makeImageURL(dimensions,item);
    }
  }

  getFallBackImage(dim) {
    if (this.constants.isWebstore) {
      return this.cartManager.makeNANImageURLFromImage(dim);

    } else {
      return "./assets/img/dummy-" + dim + ".png";
    }
  }

  imageNotFound(e,item){
    item.productImagesDTO[0].extension = "png";
    item.productImagesDTO[0].name = "dummy";
  }

  removeProductQuantityFromOpened(product){

    // this.stockCartManager.removeOneNew(product);
    if(product.quantity > 0 && this.product.quantity > 0){
      product.quantity -= 1;
      // this.enteredQuantityInOpened -= 1;
    }
    // this.refreshTotalPrice();
  }
  // removeProductQuantityFromDamaged(product){
  //   if(this.damagedQuntity > 0){
  //     this.damagedQuntity -= 1;
  //     this.enteredQuantityInDamaged -= 1;
  //   }
  // }

  updateProductQuantityToOpened(product){
    // this.gVLogger.log("update called....." + product.quantity);
    if(String(product.quantity) !=""){
      if(String(product.quantity).match(/^\d+$/)){
        this.gVLogger.log("update called....." + product.quantity);
        let enteredQuantity = product.quantity;
        this.gVLogger.log("enteredQuantity....." + enteredQuantity);
        product.quantity = 0;
        this.gVLogger.log("Total bad....." + this.totalBadQuantity());
        // this.stockCartManager.updateCartNewPopup(product);
        let quantityRemaining = this.product.quantity - this.totalBadQuantity();
        this.gVLogger.log("QuantityRemaining....." + quantityRemaining);
        if ( enteredQuantity <= this.product.quantity  && enteredQuantity <= quantityRemaining){
          product.quantity = Number(enteredQuantity);
        }else {
          product.quantity = 0;
        }

        // this.enteredQuantityInOpened = this.openedQuantity;
      }else{
        this.gVLogger.log("update called else 1....." + product.quantity);
        // product.quantity = Number(this.enteredQuantity);
        // this.stockCartManager.updateCartNewPopup(product);
        // if (product.quantity <= this.totalBadQuantity() && product.quantity <= this.product.quantity){
        //   product.quantity = Number(product.quantity);
        // }else {
          product.quantity = 0;
        // }
        // this.enteredQuantityInOpened = this.openedQuantity;
      }
    }else{
      this.gVLogger.log("update called else 2....." + product.quantity);
      // product.quantity = Number(product.quantity);
      // this.stockCartManager.updateCartNewPopup(product);
      // if (product.quantity <= this.totalBadQuantity() && product.quantity <= this.product.quantity){
      //   product.quantity = Number(product.quantity);
      // }else {
        product.quantity = 0;
      // }
      // this.enteredQuantityInOpened = this.openedQuantity;
    }
    // this.refreshTotalPrice();

  }

  addProductQuantityToOpened(item){
    if(this.totalBadQuantity() < this.product.quantity){
      item.quantity += 1;
    }

  }



}



// WEBPACK FOOTER //
// ./src/pages/mark-bad-product-model/mark-bad-product-model.ts